import { OopsSomethingWentWrong } from '@modules/common/components/OopsSomethingWentWrong';
import { useFetchRecordCount } from '@modules/common/hooks';
import {
  useGetSearchQueryContainer,
  useIsSummaryOnSearchEnabled,
} from '@modules/feed/hooks';
import { CircularProgress, Stack } from '@mui/material';
import { IsLoading } from 'v2/core/repository/edge-server/types';
import { SearchAnalysesFeedbackList } from '../SearchAnalysesFeedbackList';
import { SearchAnalysesReportWidgets } from '../SearchAnalysesReportWidgets';
import { SearchSummary } from '../SearchSummary';
import { SearchResultsNotFoundMessage } from './SearchResultsNotFoundMessage';

export function SearchAnalysesResults() {
  const queryContainer = useGetSearchQueryContainer();

  const isSummaryOnSearchEnabled = useIsSummaryOnSearchEnabled();

  const {
    data: feedbackCount,
    error,
    status,
    refetch,
  } = useFetchRecordCount({
    queryContainer,
  });

  if (IsLoading(status)) {
    return (
      <Stack alignItems="center" justifyContent="center" py={20}>
        <CircularProgress size={50} />
      </Stack>
    );
  }

  if (error) {
    return (
      <OopsSomethingWentWrong
        onDataRefresh={() => {
          refetch?.();
        }}
      />
    );
  }

  if (!IsLoading(status) && feedbackCount === 0) {
    return <SearchResultsNotFoundMessage />;
  }

  return (
    <>
      {!isSummaryOnSearchEnabled && <SearchAnalysesReportWidgets />}
      {isSummaryOnSearchEnabled && (
        <SearchSummary queryContainer={queryContainer} />
      )}
      <SearchAnalysesFeedbackList />
    </>
  );
}
